import get from 'lodash/get';

import {
  GET_CHECKOUT_MEALS_REQUEST,
  GET_CHECKOUT_MEALS_RESPONSE,
  GET_CHECKOUT_MEALS_ERROR,
} from 'actions/userIncentives';
import { GET_VIEWABLE_BASKETS_V3_RESPONSE } from 'lib/constants/v3Actions';
import { transformMealForCheckoutMeals } from 'services/RequestService/helpers';

const initialState = {};

const initializeCheckoutMeals = (currentMenusData, menuSlugs) => {
  const menusHash = menuSlugs.reduce((hash, slug) => ({ ...hash, [slug]: [] }), {});

  return {
    ...menusHash,
    ...currentMenusData,
  };
};

const addCheckoutMealsForMenu = (currentMenusData, menuSlug, checkout) => ({
  ...currentMenusData,
  [menuSlug]: {
    checkoutMeals: checkout.checkoutMeals.map(mm => transformMealForCheckoutMeals(mm)),
    checkoutMealsCategory: checkout.checkoutMealsCategory,
    isLoaded: true,
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_VIEWABLE_BASKETS_V3_RESPONSE:
      return initializeCheckoutMeals(
        state,
        (action.response.weeklyBaskets || []).filter(Boolean).map(wb => wb.menuSlug)
      );
    case GET_CHECKOUT_MEALS_REQUEST: {
      const menuSlug = action.params?.menuSlug;
      if (!menuSlug) return state;

      return {
        ...state,
        [menuSlug]: {
          ...state[menuSlug],
          isLoaded: false,
          isError: false,
        },
      };
    }
    case GET_CHECKOUT_MEALS_RESPONSE: {
      const userIncentives = action.response?.userIncentives;
      const menuSlug = userIncentives?.menuSlug;
      if (!menuSlug) return state;

      return addCheckoutMealsForMenu(state, menuSlug, userIncentives.checkoutMeals);
    }
    case GET_CHECKOUT_MEALS_ERROR: {
      const menuSlug = action.params?.menuSlug;
      if (!menuSlug) return state;

      return {
        ...state,
        [menuSlug]: {
          ...state[menuSlug],
          isLoaded: true,
          isError: true,
          checkoutMeals: [],
        },
      };
    }
    default:
      return state;
  }
};

export const selectCheckoutMealsForMenu = (state, slug) => get(state, [slug, 'checkoutMeals'], []);
export const selectCheckoutMealsLoadedForMenu = (state, slug) =>
  get(state, [slug, 'isLoaded'], false);
export const selectCheckoutMealsCategory = (state, slug) =>
  get(state, [slug, 'checkoutMealsCategory']);
